import { workflowAxiosPost } from "../utils/workflowAuthHeaders";

const historicoTitulos = async (
  token,
  codigoCliente,
  loja,
  emissaoInicial,
  emissaoFinal,
  vencimentoInicial,
  vencimentoFinal,
  situacao,
  username,
  password
) => {
  const baseUrl = "https://workflow.grupocenze.com.br:38137/rest/";

  const data = {
    codigo: codigoCliente,
    loja: loja,
    emissao_inicial: emissaoInicial,
    emissao_final: emissaoFinal,
    vencimento_inicial: vencimentoInicial,
    vencimento_final: vencimentoFinal,
    pagamento_inicial: "",
    pagamento_final: "",
    situacao: situacao
  };

  try {
    const response = await workflowAxiosPost(
      `${baseUrl}historico_titulos`,
      data,
      {},
      { token, username, password }
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao fazer a requisição:", error);
    throw error;
  }
};

export default historicoTitulos;
